import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

const TestModeBanner = () => {
  return (
    <div className="bg-red-600 text-white px-4 py-2 flex items-center justify-center fixed top-0 left-0 right-0 z-[9999]">
      <AlertTriangle className="h-4 w-4 mr-2" />
      <p className="text-sm font-medium">
        TEST MODE: This account is in test mode. 
        <Link 
          to="/app/merchant-application?source=InvoiceBug" 
          className="ml-2 underline hover:text-gray-200 font-semibold"
        >
          Set up credit cards to start collecting payments
        </Link>
      </p>
    </div>
  );
};

export default TestModeBanner; 